export default __webpack_public_path__ + "static/media/Z.a204e8b3.svg";